/**
 * IP18 preorder Find Your kit card — swaps Pro / Pro Max variant price and checkout.
 */
(function () {
  'use strict';

  class Ip18PreorderKitCard extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var script = this.querySelector('[data-kit-json]');
      try {
        this._variants = JSON.parse(script && script.textContent ? script.textContent : '[]');
      } catch (e) {
        this._variants = [];
      }

      this._select = this.querySelector('[data-kit-select]');
      this._price = this.querySelector('[data-kit-price]');
      this._rule = this.querySelector('[data-kit-rule]');
      this._sale = this.querySelector('[data-kit-sale]');
      this._note = this.querySelector('[data-kit-note]');
      this._buy = this.querySelector('[data-kit-buy]');
      this._atc = this.querySelector('[data-kit-atc]');
      this._pdp = this.querySelector('[data-kit-pdp]');

      if (this._select) {
        this._onChange = this._onChange.bind(this);
        this._select.addEventListener('change', this._onChange);
      }
    }

    disconnectedCallback() {
      if (this._select && this._onChange) {
        this._select.removeEventListener('change', this._onChange);
      }
    }

    _onChange(event) {
      var variant = this._find(event.target.value);
      if (variant) this._apply(variant);
    }

    _find(slot) {
      for (var i = 0; i < this._variants.length; i += 1) {
        if (this._variants[i].slot === slot) return this._variants[i];
      }
      return null;
    }

    _apply(variant) {
      if (this._price) {
        this._price.textContent = variant.price || '';
        this._price.hidden = !variant.price;
        if (variant.sale) this._price.classList.add('is-original');
        else this._price.classList.remove('is-original');
      }

      var hasSale = !!variant.sale;
      if (this._rule) this._rule.hidden = !hasSale;
      if (this._sale) {
        this._sale.textContent = variant.sale || '';
        this._sale.hidden = !hasSale;
      }
      if (this._note) {
        this._note.hidden = !hasSale || !(this._note.textContent || '').trim();
      }

      if (this._buy) {
        if (variant.available && variant.checkout) {
          this._buy.setAttribute('href', variant.checkout);
          this._buy.removeAttribute('aria-disabled');
          this._buy.classList.remove('is-disabled');
        } else {
          this._buy.removeAttribute('href');
          this._buy.setAttribute('aria-disabled', 'true');
          this._buy.classList.add('is-disabled');
        }
      }

      if (this._pdp) {
        if (variant.pdp) this._pdp.setAttribute('href', variant.pdp);
        else this._pdp.removeAttribute('href');
      }

      if (this._atc) {
        if (variant.id) {
          this._atc.dataset.variantId = String(variant.id);
        } else {
          this._atc.dataset.variantId = '';
        }
        if (variant.available) {
          this._atc.removeAttribute('disabled');
          this._atc.textContent = this._atc.dataset.labelAtc || this._atc.textContent;
        } else {
          this._atc.setAttribute('disabled', '');
          if (variant.id) {
            this._atc.textContent = this._atc.dataset.labelSold || this._atc.textContent;
          } else {
            this._atc.textContent = this._atc.dataset.labelAtc || this._atc.textContent;
          }
        }
      }
    }
  }

  if (!customElements.get('ip18-preorder-kit-card')) {
    customElements.define('ip18-preorder-kit-card', Ip18PreorderKitCard);
  }
})();
